export const mappingSalutation = {
  907530000: 'Herr',
  907530001: 'Frau',
  907530002: 'Ohne Anrede',
  390220001: 'Divers'
}

export const mappingTitle = {
  907530000: 'B.A.',
  907530001: 'B.Sc.',
  907530002: 'Dipl.-Betriebsw.',
  907530003: 'Dipl.-Biol.',
  907530004: 'Dipl.-Des.',
  907530005: 'Dipl.-Inf.',
  907530006: 'Dipl.-Ing.',
  907530007: 'Dipl.-Kff.',
  907530008: 'Dipl.-Kfm.',
  907530009: 'Dipl.-Päd.',
  907530010: 'Dipl.-Psych.',
  907530011: 'Dipl.-Soz.päd.',
  907530012: 'Dipl.-Wirtsch.-Inf.',
  907530013: 'Dr.',
  907530014: 'Dr. med.',
  907530015: 'Dr. rer. nat.',
  907530016: 'Dr.-Ing.',
  907530017: 'Dr.med.dent.',
  907530018: 'Dr.Phil.',
  907530019: 'Ing.',
  907530020: 'M.A.',
  907530021: 'M.Sc.',
  907530022: 'PD Dr.',
  907530023: 'Prof.',
  907530024: 'Prof. Dr.',
  907530025: 'Prof. Dr. med.'
}

export const translateCrmCodes = (
  storageKey,
  value,
  reversedMapping = false
) => {
  switch (storageKey) {
    case 'salutation':
      if (reversedMapping) {
        const reversed = Object.fromEntries(
          Object.entries(mappingSalutation).map(([k, v]) => [v, k])
        )

        return Object.keys(reversed).includes(value) ? reversed[value] : value
      }

      return Object.keys(mappingSalutation).includes(value)
        ? mappingSalutation[value]
        : value

    case 'title':
      if (reversedMapping) {
        const reversed = Object.fromEntries(
          Object.entries(mappingTitle).map(([k, v]) => [v, k])
        )

        return Object.keys(reversed).includes(value) ? reversed[value] : value
      }

      return Object.keys(mappingTitle).includes(value)
        ? mappingTitle[value]
        : value

    default:
      return value
  }
}
